import {CommonService} from './../../../shared/utils/common.service';
import {UtilsService} from './../../../shared/utils/utils.service';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {moduloGaritas} from '../diccionarios/balanzaModulo.js';
import {IUsuario, IUsuarioAll} from '../modelos/IUsuario';

@Injectable({
  providedIn: 'root'
})
export class UsuariosService {

  private diccionarioModulo: any;
  private url: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloGaritas;
    this.url = this._util.getUrlBascula();
  }

  obtenerPorId(username: string): Observable<IUsuario> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.usuarios.obtenerPorId + username
    );
  }

  obtenerTodo(): Observable<IUsuarioAll[]> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.usuarios.obtenerTodo
    ).pipe(
      map(m => m.filter(f => f.status == 1 && f.login2.trim()))
    );
  }
}
